module.exports = __webpack_public_path__ + "img/icon-close-seashell.ac0ab7bc.svg";